/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes */
// Extending From
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class EnvironmentWarning extends Component {
  // Services
  @service
  environment;

  // State
  // shouldShow tracks whether the environmental warning banner should be hidden
  // from the user, based on dismissing the warning bar.
  @tracked
  shouldShow = true;

  // Methods
  // shouldWarn detects if the warning banner should be shown in the given
  // environment.
  @computed('environment.name')
  get shouldWarn() {
    return this.environment.name !== 'production';
  }

  // canDismiss detects if the warning banner can be dismissed in a specific
  // environment.
  @computed('environment.name')
  get canDismiss() {
    return !(
      this.environment.name === 'production' || this.environment.name === 'beta'
    );
  }

  // dataType returns the type of data the user is working on based on the
  // specific environment.
  @computed('environment.name')
  get dataType() {
    switch (this.environment.name) {
      case 'local':
      case 'development':
      case 'staging':
        return 'dummy';

      default:
        return 'live';
    }
  }

  // hideMe provides an action to disable the environmental warning banner
  // from showing in the DOM. This is mainly to enable taking screenshots and
  // creation of documentation in pre-production environments.
  @action
  hideMe() {
    this.shouldShow = false;
  }
}
